import React, { createContext, useContext, useState } from 'react';

interface TransferSidebarContextValue {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
}

const TransferSidebarContext =
  createContext<TransferSidebarContextValue | null>(null);

export const TransferSidebarProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // Collapsed by default; auto-opens when a transfer starts (wired in Phase 2)
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  return (
    <TransferSidebarContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </TransferSidebarContext.Provider>
  );
};

export const useTransferSidebar = () => {
  const ctx = useContext(TransferSidebarContext);
  if (!ctx)
    throw new Error(
      'useTransferSidebar must be used within a TransferSidebarProvider'
    );
  return ctx;
};
